<ng-container *ngFor="let step of steps; let i = index;">
  <span *ngIf="i > 0" class="line" [class.active]="currentStep >= i"></span>
  <a class="step" [class.current]="currentStep >= i" [class.active]="canOpenStep(i)" routerLink="/{{step.path}}">
    <div class="label">{{step.label}}</div>
    <div class="circle-border">
      <div class="circle">{{i + 1}}</div>
    </div>
  </a>
</ng-container>
